import { render, staticRenderFns } from "./StartupOffer.vue?vue&type=template&id=18085905"
import script from "./StartupOffer.vue?vue&type=script&lang=ts"
export * from "./StartupOffer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports